import { URL_ENDPOINTS } from "./../../constants/index";
import axios from "axios";
import { TokenType } from "./types";

const URL = URL_ENDPOINTS.BASE_URL + URL_ENDPOINTS.SECURITY;

const SecurityService = {
  authenticate: async (password: string): Promise<TokenType> => {
    const body = `username=token_temporal&password=${encodeURIComponent(
      password
    )}&grant_type=password&scope=PEPPER_PAYMENT`;
    const response = await axios.post(URL, body, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Basic ${process.env.REACT_APP_CLIENT_SECRET}`,
      },
    });
    return response.data.data;
  },
};

export default SecurityService;
